import { getMessagesByLang } from './i18n';
import Tangerine from '.';

export default {
  unstyled: true,
  pt: Tangerine,
  ptOptions: { mergeSections: true, mergeProps: true },
  locale: getMessagesByLang('pt-BR'),
};
